import type { Context } from '@/overmind';

import { getFeaturesOnCalculationTacticResult } from './reactions/getFeaturesOnCalculationTacticResult';
import { onEvaluation } from './reactions/onEvaluation';

export const setupReactions = (context: Context) => {
  getFeaturesOnCalculationTacticResult(context);
  onEvaluation(context);
};
